// extracted by mini-css-extract-plugin
export default {"gifts_container":"Gifts_gifts_container__YHfru"};